import { C as s } from "./component-B88NZlIm.js";
import { d as r } from "./utilities-D-QcnR4L.js";
class i extends s {
  requiredRefs = ["content", "trigger", "moreLabel", "lessLabel"];
  connectedCallback() {
    (super.connectedCallback(),
      this.#t(),
      (this.#e = new ResizeObserver(() => this.#t())),
      this.#e.observe(this.refs.content));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(), this.#e?.disconnect());
  }
  #e;
  toggle() {
    const e = !(this.getAttribute("data-expanded") === "true");
    (this.setAttribute("data-expanded", String(e)),
      this.refs.trigger.setAttribute("aria-expanded", String(e)),
      (this.refs.moreLabel.hidden = e),
      (this.refs.lessLabel.hidden = !e));
  }
  #t() {
    if (this.getAttribute("data-expanded") === "true") return;
    const t = this.refs.content,
      e = t.scrollHeight - 1 > t.clientHeight;
    this.toggleAttribute("data-overflowing", e);
  }
}
r("read-more-text", i);
